export const COMBINED_SCHEDULE_UPDATED = 'COMBINED_SCHEDULE/UPDATED';
export const BATCH_COMBINED_SCHEDULE_UPDATED = 'BATCH_COMBINED_SCHEDULE/UPDATED';
export const ERROR = 'FETCH_COMBINED_SCHEDULE_ERROR';
export const START = 'FETCH_COMBINED_SCHEDULE_START';
export const SUCCESS = 'FETCH_COMBINED_SCHEDULE_SUCCESS';
export const SPLIT_COMBINED_SCHEDULE_INTERVAL = 'SPLIT_COMBINED_SCHEDULE_INTERVAL';
export const SCHEDULE_WARNINGS_RECEIVED = 'COMBINED_SCHEDULE_WARNINGS_RECEIVED';
export const SCHEDULE_WARNINGS_CLEARED = 'COMBINED_SCHEDULE_WARNINGS_CLEARED';
